import Compare from "../marketing/Compare";

export default function CompareWhoBrewVsBlinq() {
  return (
    <Compare
      competitor="Blinq"
      competitorUrl="https://blinq.me"
      path="/compare/whobrew-vs-blinq"
      seoTitle="WhoBrew vs Blinq — honest NFC business card comparison"
      seoDescription="A side-by-side comparison of WhoBrew and Blinq. Pricing, features, lead capture, and where each one fits. No spin."
      positioning="Blinq is the consumer-friendly leader in the digital business card category, with a freemium app and a deep iOS catalog of share methods. WhoBrew sits in adjacent territory with a built-in custom contact-form system and a free tier that doesn't shrink as you grow."
      wedge={{
        headline: "Free forever, and a smarter form",
        italicWord: "smarter",
        subhead:
          "Blinq's free tier ends. Their pricing tiers exist to graduate users. WhoBrew's free tier is the long-term home for anyone who doesn't need three cards or a thousand visits a month — and the floor doesn't shrink. Beyond pricing: WhoBrew's contact form lets you ask up to four custom qualifying questions per link, on Pro. A sales rep's \"Talk to us\" form, a recruiter's \"Apply\" form, and a realtor's \"Schedule a tour\" form should not have the same fields.",
      }}
      outcomeStats={[
        {
          label: "Free tier",
          whobrew: "Free forever",
          competitor: "Limited; gated features",
          context: "No card-count cap on the starter.",
        },
        {
          label: "Custom form fields",
          whobrew: "Up to 4 per link",
          competitor: "Standard fields only",
          context: "Per-persona qualifying questions on Pro.",
        },
        {
          label: "Per-link source attribution",
          whobrew: "Surfaced in /leads",
          competitor: "Not surfaced",
          context: "Know which event drove which lead.",
        },
      ]}
      rows={[
        { feature: "Free tier",                whobrew: "Free forever",        competitor: "Free tier (limited)" },
        { feature: "Starting paid plan",       whobrew: "$4.99 / month",       competitor: "$5.99 / month" },
        { feature: "NFC card",                 whobrew: "$14.99 once",         competitor: "$9.99 (Essential)" },
        { feature: "Cards per account",        whobrew: "Up to 3 (Pro)",       competitor: "Up to 5 (paid)" },
        { feature: "Apple Wallet pass",        whobrew: "On roadmap",          competitor: true },
        { feature: "Lead capture form",        whobrew: true,                  competitor: true },
        { feature: "Custom contact-form fields", whobrew: "Up to 4 per link (Pro)", competitor: "Standard fields" },
        { feature: "Per-link source attribution", whobrew: true,               competitor: false },
        { feature: "Per-link click analytics", whobrew: true,                  competitor: true },
        { feature: "Custom themes",            whobrew: "11 included",         competitor: "Custom (paid)" },
        { feature: "Email signature builder",  whobrew: true,                  competitor: true },
      ]}
      whereTheyWin="Blinq has been at this for longer, ships an Apple Wallet pass that is genuinely well-built, and has the deepest catalog of share methods (widgets, virtual backgrounds, smartwatch faces). Their consumer app is polished and their iOS / Android experience is more mature than WhoBrew's. If you need an Apple Wallet pass today, Blinq is the answer today."
      recommendation="Pick Blinq if you specifically need the Apple Wallet pass and want a consumer-app-style experience with widgets and watch faces. Pick WhoBrew if you want a free tier that doesn't shrink as you grow and a contact form that asks the questions your role actually qualifies on."
    />
  );
}
